module.exports = __webpack_public_path__ + "img/bump(3).75f62334.jpg";